import { render, staticRenderFns } from "./CustomDelimiters.vue?vue&type=template&id=770c6732&"
import script from "./CustomDelimiters.vue?vue&type=script&lang=js&"
export * from "./CustomDelimiters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports